import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./DesktopBars.css";
import appIconWhite from "../assets/appIcon.svg";
import appIconBlue from "../assets/socialPawsLogo.svg";

const DesktopTopBar = ({
  onBack,
  showBack = false,
  backColor = "#fff",

  showProgress = false,
  progressIconSrc,
  progressPercent = 0,
  iconLeft = 0,

  showLogo = false,
  logoColor = "#fff",
  appName = "Social Paws",
  blueLogo = false,
  onLogoClick,

  className = "",
  iconWidth = "75px",
}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    } else {
      localStorage.setItem("dashboard_current_view", "map");
      navigate("/dashboard-switcher", { state: { resetFilter: true } });
    }
  };

  return (
    <div className={`desktop-top-bar ${className}`}>
      {/* Absolute Top-Left: Back Button */}
      {showBack && (
        <button
          className="dtb-back-btn"
          onClick={onBack || (() => navigate(-1))}
          style={{ color: backColor }}
        >
          <ArrowLeft size={24} color={backColor} strokeWidth={3} />
          <span>Back</span>
        </button>
      )}

      {/* Absolute Top-Center: Progress Bar */}
      {showProgress && (
        <div className="dtb-progress-container">
          <div
            className="dtb-progress-icon-wrapper"
            style={{
              left: `calc(${iconLeft}% - 45px)`,
            }}
          >
            {progressIconSrc && (
              <img
                src={progressIconSrc}
                alt="Progress"
                style={{ width: iconWidth }}
              />
            )}
          </div>
          <div className="dtb-progress-track">
            <div
              className="dtb-progress-fill"
              style={{ width: `${progressPercent}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Absolute Top-Right: Logo */}
      {showLogo && (
        <div
          className="dtb-header-logo"
          style={{ color: logoColor }}
          onClick={handleLogoClick}
        >
          <img
            src={blueLogo ? appIconBlue : appIconWhite}
            alt={appName}
            className="dtb-logo-img"
          />
          <span>{appName}</span>
        </div>
      )}
    </div>
  );
};

export default DesktopTopBar;
